import { all, put, takeLatest } from 'redux-saga/effects';

import { platformsTypes } from '@src/ducks/platforms/platforms';

export function * watchPlatforms() {
    yield takeLatest(platformsTypes.PLATFORMS_GET, onPlatformsGet);
    yield takeLatest(platformsTypes.PLATFORMS_SUCCESS, onPlatformsGetResponse);
}

function * onPlatformsGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

function * onPlatformsGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'platforms') {
        return yield all([
            put({
                type: platformsTypes.PLATFORMS_SET,
                payload: response,
            }),
        ]);
    }
}
